import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAb_jB5bhlSSTW_lVa2CT6dLOTwCrQkM3o",
  authDomain: "wealthbuilders-crm-9c323.firebaseapp.com",
  projectId: "wealthbuilders-crm-9c323",
  storageBucket: "wealthbuilders-crm-9c323.firebasestorage.app",
  messagingSenderId: "939575270287",
  appId: "1:939575270287:web:4f7b6f2688dde8f99cc9fa",
  measurementId: "G-240E44FNWS",
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

/** Google provider:
 *  - contacts.readonly scope for People API
 *  - prompt consent to ensure a token with the new scope
 *  - include_granted_scopes to reuse prior grants
 */
export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope("https://www.googleapis.com/auth/contacts.readonly");
googleProvider.setCustomParameters({
  prompt: "consent",
  include_granted_scopes: "true",
});
